import { forwardRef } from 'react'
import clsx from 'clsx'
import Input, { InputStyles } from './Input'
import InputMask from 'react-input-mask'
import { datepickerIcons } from './AppDatePicker'

interface TimeRangePickerProps {
    label?: string
    error?: string
    helpText?: string
    inputStyle?: InputStyles
    value?: string
    onChange?: (
        raw: string,
        value: { start: Date | null; end: Date | null },
    ) => void
}

const parseTime = (str: string) => {
    if (!/^\d{2}:\d{2}$/.test(str)) return null
    const [h, m] = str.split(':').map(Number)
    if (h > 23 || m > 59) return null
    const date = new Date()
    date.setHours(h, m, 0, 0)
    return date
}

const TimeRangePicker = forwardRef<HTMLInputElement, TimeRangePickerProps>(
    (
        {
            label,
            error,
            helpText,
            inputStyle = InputStyles.solid,
            value,
            onChange,
        },
        ref,
    ) => {
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const raw = e.target.value
            const [startStr, endStr] = raw.split('-').map(s => s.trim())
            const startDate = parseTime(startStr)
            const endDate = parseTime(endStr)

            onChange?.(raw, { start: startDate, end: endDate })
        }

        return (
            <div className="w-full">
                <InputMask
                    mask="99:99 - 99:99"
                    maskChar="_"
                    value={value}
                    onChange={handleChange}
                >
                    {(inputProps: any) => (
                        <Input
                            {...inputProps}
                            ref={ref}
                            label={label}
                            error={error}
                            helpText={helpText}
                            icon={datepickerIcons.timeIcon}
                            inputStyle={inputStyle}
                            placeholder="HH:MM - HH:MM"
                        />
                    )}
                </InputMask>
            </div>
        )
    },
)

export default TimeRangePicker
